import React, {useEffect, useImperativeHandle} from 'react';
import {Modal, Form, Input, Select, Button} from 'antd';

const {Option} = Select;

const UserModal = React.forwardRef((props, ref) => {
    const {visible, onClose, roles, user, isEdit, handleAdd, handleEdit, authRedux} = props;
    const [form] = Form.useForm();

    useImperativeHandle(ref, () => ({
        form,
    }));

    useEffect(() => {
        if (user) {
            form.setFieldsValue(user);
        } else {
            form.resetFields();
        }
    }, [user, form]);

    return (
        <Modal
            title={isEdit ? 'Edit User' : 'Add New User'}
            open={visible}
            onCancel={onClose}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Cancel
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    onClick={() => {
                        form
                            .validateFields()
                            .then((values) => {
                                // handle form submission
                                if (isEdit) {
                                    handleEdit(values);
                                } else {
                                    handleAdd(values);
                                }
                            })
                            .catch((info) => {
                                console.log('Validate Failed:', info);
                            });
                    }}
                >
                    Submit
                </Button>,
            ]}
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    name="name"
                    label="Name"
                    rules={[{required: true, message: 'Please input name!'}]}
                >
                    <Input/>
                </Form.Item>

                <Form.Item
                    name="email"
                    label="Email"
                    rules={[{required: true, message: 'Please input email!'}]}
                >
                    <Input type="email"/>
                </Form.Item>

                <Form.Item
                    name="password"
                    label="Password"
                    rules={
                        isEdit
                            ? [] // No validation if editing
                            : [{required: true, message: 'Please input password!'}]
                    }
                >
                    <Input.Password/>
                </Form.Item>


                <Form.Item
                    name="role"
                    label="Role"
                    rules={[{required: true, message: 'Please select role!'}]}
                >
                    <Select placeholder="Select a role">
                        {roles.map((role, key) => (
                            <Option key={key} value={role.role_id}>
                                {role.description}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    );
});

export default UserModal;
